import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import supabase from '../../supabase-client';

// Import detail screens
import BookDetailScreen from '../pages/book-detail-screen';
import BibleDetailScreen from '../pages/bible-detail-screen';
import ThingDetailScreen from '../pages/thing-detail-screen';

const ProductDetailRouter = () => {
  const [searchParams] = useSearchParams();
  const productId = searchParams.get('id');
  
  const [productType, setProductType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProductType = async () => {
      if (!productId) {
        setError('ID de producto no proporcionado');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const { data, error: fetchError } = await supabase
          .from('productbook')
          .select('*')
          .eq('id_product', productId)
          .single();

        if (fetchError) {
          throw new Error('Producto no encontrado');
        }

        if (!data) {
          throw new Error('Producto no encontrado');
        }

        // Determine product type based on product fields
        let detectedType = 'book'; // default
        
        if (data.format_product && data.language_product) {
          detectedType = 'bible';
        } else if (data.is_book_product === true || data.pages_product) {
          detectedType = 'book';
        } else {
          detectedType = 'thing';
        }
        
        console.log('🔍 Product type detection:', {
          productId,
          format_product: data.format_product,
          language_product: data.language_product,
          is_book_product: data.is_book_product,
          pages_product: data.pages_product,
          detectedType
        });
        
        setProductType(detectedType);
      } catch (err) {
        console.error('Error fetching product type:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProductType();
  }, [productId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="text-muted-foreground">Cargando producto...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-4 max-w-md mx-auto px-4">
          <div className="text-6xl">😕</div>
          <h1 className="text-2xl font-bold text-foreground">Producto no encontrado</h1>
          <p className="text-muted-foreground">{error}</p>
          <button
            onClick={() => window.history.back()}
            className="bg-primary text-primary-foreground px-6 py-2 rounded-md hover:bg-primary/90 transition-colors"
          >
            Volver atrás
          </button>
        </div>
      </div>
    );
  }

  // Route to appropriate detail screen based on product type
  switch (productType) {
    case 'book':
      return <BookDetailScreen />;
    case 'bible':
      return <BibleDetailScreen />;
    case 'thing':
      return <ThingDetailScreen />;
    default:
      return (
        <div className="min-h-screen bg-background flex items-center justify-center">
          <div className="text-center space-y-4 max-w-md mx-auto px-4">
            <div className="text-6xl">❓</div>
            <h1 className="text-2xl font-bold text-foreground">Tipo de producto desconocido</h1>
            <p className="text-muted-foreground">
              El tipo de producto "{productType}" no es reconocido por el sistema.
            </p>
            <button
              onClick={() => window.history.back()}
              className="bg-primary text-primary-foreground px-6 py-2 rounded-md hover:bg-primary/90 transition-colors"
            >
              Volver atrás
            </button>
          </div>
        </div>
      );
  }
};

export default ProductDetailRouter;

